import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { environment } from '../../../../../../../public/environments/environment';
import { ApiService } from '../../../services/Api.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';


@Component({
  selector: 'app-job-details',
  standalone: false,
  templateUrl: './job-details.component.html'
})
export class JobDetailsComponent {
  dataLoading = true;

  actionLoading = '';

  detailsLink!: string;

  jobId!: string;
  details!: any;
  env = environment;


  id: any;
  companyId!: any;

  language: any;

  mainColor = '#5252d8';
  mainColorWithoutHash!: any;

  titleColor = '#4d5b70';
  titleColorWithoutHash!: any;

  textColor = '#6B6B7C';
  textColorWithoutHash!: any;

  backgroundColor = '#f8f8ff';
  backgroundColorWithoutHash!: any;

  constructor(
    private translate: TranslateService,
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    public location: Location
  ) {
    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('company_id')) {
        this.companyId = params.get('company_id');
      }
    });
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['id']) {
        this.id = params['id'];
      }


      if (params['language'] && (params['language'] === 'ar' || params['language'] === 'en')) {
        this.language = params['language'];
        const paramLang = params['language'];
        const storedLang = localStorage.getItem('language');

        if (storedLang !== paramLang) {
          this.translate.use(paramLang);
          localStorage.setItem('language', paramLang);
          // location.reload();
          return;
        }
      }

      if (params['color']) {
        this.mainColor = '#' + params['color'];
        this.mainColorWithoutHash = params['color'];
        document.documentElement.style.setProperty('--primary', this.mainColor);
      }

      if (params['title_color']) {
        this.titleColor = '#' + params['title_color'];
        this.titleColorWithoutHash = params['title_color'];
        document.documentElement.style.setProperty('--gray-0', this.titleColor);
      }

      if (params['font_color']) {
        this.textColor = '#' + params['font_color'];
        this.textColorWithoutHash = params['font_color'];
        document.documentElement.style.setProperty('--gray-2', this.textColor);
      }

      if (params['background_color']) {
        this.backgroundColor = '#' + params['background_color'];
        this.backgroundColorWithoutHash = params['background_color'];
        document.documentElement.style.setProperty('--background_primary_ff', this.backgroundColor);
      }
    });
  }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    const filter = { id: this.id, language: this.language };
    // if (this.id) {
    //   filter.id = this.id;
    // }
    // if (this.language) {
    //   filter.language = this.language;
    // }
    this.apiService.getJobDetails(filter).subscribe((res: any) => {
      this.details = res.data;
      this.dataLoading = false;
    })
  }


  showComp(job: any) {
    let html = `
          <div class='font-16 font-700 mb-4'>${job.job_title}</div>
          <div class='text-start'>`;
    job.competences.forEach((e: any) => {
      html += `
          <div class='mb-2'>
            <div class='badge badge-gray0${!e.selected ? ' opacity-50' : ''}'>${e.name}</div>
          </div>`;
    });
    html += '</div>'
    Swal.fire({
      // title: job.job_title,
      html,
      confirmButtonText: this.translate.instant('general.ok'),
    });
  }

  back() {
    this.location.back();
  }
}
